<template lang="pug">
	.company-detail
		Loader(v-if="isLoading", :fullscreen="true")
		dx-tab-panel(v-else-if="company", :selectedIndex.sync="mainTabIndex")
			dx-item(title="General")
				template(#default)
					dx-validation-group.flex-row.space-large.details-segment.wrap(ref="validationGroup")
						.flex-col.space-large.flex-1
							.flex-row
								.font-large.upper {{company.Name}}
							.flex-row.space-large.justify
								.field.space.flex-1
									.font-small.upper.grey {{$tCaption('Address')}}
									dx-text-box(:value.sync="company.Address", :disabled="isLoading")
								.field.space.flex-1
									.font-small.upper.grey {{$tCaption('Address 2')}}
									dx-text-box(:value.sync="company.Address2", :disabled="isLoading")
								.field.space.flex-1
									.font-small.upper.grey {{$tCaption('Address 3')}}
									dx-text-box(:value.sync="company.Address3", :disabled="isLoading")
								.flex-col
									.font-small.grey.upper {{$tCaption('Time zone')}}
									Dropdown(
										:getTotal="(data) => data.TotalNumberOfRecords",
										:getItems="(data) => data.Results",
										:getData="$Data.getTimeZones",
										:columns="[{ dataField: 'DisplayName', caption: $tCaption('Time zone') }]",
										displayExpr="DisplayName",
										valueExpr="Id",
										:selectedItems="company.TimeZoneId",
										:showColumnHeaders="false",
										:filtersVisible="false",
										:searchVisible="true",
										:multiple="false",
										:minSearchLength="0",
										@select-data="item => $set(company, 'TimeZoneId', item ? item.Id : null)"
									)
							.flex-row.space-large
								.flex-col.field.space.flex-1
									.font-small.upper.grey {{$tCaption('City')}}
									dx-text-box(:value.sync="company.City", :disabled="isLoading")
								.flex-col.field.space.flex-1
									.font-small.upper.grey {{$tCaption('State/Region')}}
									dx-text-box(:value.sync="company.State", :disabled="isLoading")
								.flex-col.field.space.flex-1
									.font-small.upper.grey {{$tCaption('Zip/Postal code')}}
									dx-text-box(:value.sync="company.Zip", :disabled="isLoading")
								.flex-col.space.flex-1
									.font-small.upper.grey {{$tCaption('Country')}}
									span {{company.Country.Name}}
							.flex-row.tb-padding
								.flex-col.space.flex-2.detail-tile
									.flex-row.wrap.buttons-group
										.button-item
											DxButton(:text="getCounted($tCaption('Contacts'), totalRegistered + totalInvited + totalWaitingApproval)", stylingMode="text", @click="tab = 'contacts'", :hoverStateEnabled="false", :activeStateEnabled="false", :focusStateEnabled="false", :type="tab === 'contacts' ? 'default' : 'normal'")
										.button-item
											DxButton(:text="$tCaption('My invoices')", stylingMode="text", @click="tab = 'invoices'", :hoverStateEnabled="false", :activeStateEnabled="false", :focusStateEnabled="false", :type="tab === 'invoices' ? 'default' : 'normal'")
										.button-item(v-if="$auth.isAgency() || $auth.isAdvertiser()")
											DxButton(:text="getCounted($tCaption('My stations'), totalStations)", stylingMode="text", @click="tab = 'stations'", :hoverStateEnabled="false", :activeStateEnabled="false", :focusStateEnabled="false", :type="tab === 'stations' ? 'default' : 'normal'")
										.button-item(v-if="$auth.isAdvertiser() || $auth.isStationOwner()")
											DxButton(:text="getCounted($tCaption('My agencies'), totalAgencies)", stylingMode="text", @click="tab = 'agencies'", :hoverStateEnabled="false", :activeStateEnabled="false", :focusStateEnabled="false", :type="tab === 'agencies' ? 'default' : 'normal'")
										.button-item(v-if="$auth.isAgency() || $auth.isStationOwner()")
											DxButton(:text="getCounted($tCaption('My advertisers'), totalAdvertisers)", stylingMode="text", @click="tab = 'advertisers'", :hoverStateEnabled="false", :activeStateEnabled="false", :focusStateEnabled="false", :type="tab === 'advertisers' ? 'default' : 'normal'")
										.button-item
											DxButton(:text="getCounted($tCaption('My invites'), totalInvites)", stylingMode="text", @click="tab = 'companiesInvites'", :hoverStateEnabled="false", :activeStateEnabled="false", :focusStateEnabled="false", :type="tab === 'companiesInvites' ? 'default' : 'normal'")
									.flex-col
										ListView(:visible="tab === 'contacts' && contactsTab == 'registered'", name="registered", :columnHidingEnabled="false", ref="registeredUsers", initialView="table", :hideViewsSelection="true", :getTotal="(r) => { totalRegistered = r.TotalNumberOfRecords; return r.TotalNumberOfRecords; }", :getItems="r => r.Results", :getData="(a,b,c) => getCompanyContacts(a,b,c,2)", :columns="registeredContactsColumns")
											DetailContactsTabs(slot="left-actions", v-model="contactsTab", :totalRegistered="totalRegistered", :totalInvited="totalInvited", :totalWaitingApproval="totalWaitingApproval")
											template(v-slot:listing-cell-template="{ data }")
												.flex-row.space
													DxButton(icon="trash", type="danger", stylingMode="text", @click="deleteContact(data)", :disabled="approvingContacts.indexOf(data.Oid) > -1")
										ListView(:visible="tab === 'contacts' && contactsTab == 'invited'", name="invited", :columnHidingEnabled="false", ref="invitedUsers", initialView="table", :hideViewsSelection="true", 
											:getTotal="(r) => { totalInvited = r.TotalNumberOfRecords; return r.TotalNumberOfRecords; }", :getItems="r => r.Results", :getData="(a,b,c) => getCompanyContacts(a,b,c,3)", :columns="invitedContactsColumns")
											DetailContactsTabs(slot="left-actions", v-model="contactsTab", :totalRegistered="totalRegistered", :totalInvited="totalInvited", :totalWaitingApproval="totalWaitingApproval")
											template(v-slot:listing-cell-template="{ data }")
												.flex-row.space
													DxButton(icon="trash", type="danger", stylingMode="text", @click="deleteContact(data)", :disabled="approvingContacts.indexOf(data.Oid) > -1")
											.flex-row.space.align-center(slot="right-actions")
												DxButton(icon="plus", :text="$tCaption('New invite')" @click="openInvite")
										ListView(:visible="tab === 'contacts' && contactsTab == 'waitingApprove'", :columnHidingEnabled="false", name="waitingApprove", ref="waitinigApproveUsers", initialView="table", :hideViewsSelection="true", 
											:getTotal="(r) => { totalWaitingApproval = r.TotalNumberOfRecords; return r.TotalNumberOfRecords; }", :getItems="r => r.Results", :getData="(a,b,c) => getCompanyContacts(a,b,c,1)", :columns="waitingApproveContactsColumns")
											DetailContactsTabs(slot="left-actions", v-model="contactsTab", :totalRegistered="totalRegistered", :totalInvited="totalInvited", :totalWaitingApproval="totalWaitingApproval")
											template(v-slot:listing-cell-template="{ data }")
												.flex-row.space
													DxButton(icon="check", :text="$tCaption('Approve')", @click="approveContact(data)", :disabled="approvingContacts.indexOf(data.Oid) > -1")
													DxButton(icon="trash", type="danger", stylingMode="text", @click="deleteContact(data)", :disabled="approvingContacts.indexOf(data.Oid) > -1")
										ListView(:visible="tab == 'stations'", name="stations", :columnHidingEnabled="true", ref="stations", initialView="table", :hideViewsSelection="true", 
											:getTotal="(r) => { totalStations = r.TotalNumberOfRecords; return r.TotalNumberOfRecords; }", :getItems="r => r.Results", :getData="(a,b,c) => $Data.getExternalCompanies(a, b, {...(c || {}), byType: 1 })", 
											:columns="companiesByTypeColumns")
											.flex-row.space.align-center(slot="left-actions")
												DxButton(icon="fas fa-broadcast-tower", :text="$tCaption('Invite station owner')" @click="openCompanyInvite(1)")
											template(v-slot:name-cell-template="{ data }")
												LinkedCompanyName(:company="data", @invited="$refs.stations.reload()")
											template(v-if="isPermissionsLoaded", v-slot:permissions-cell-template="{ data }")
												.flex-row.full-width.justify.align-center
													DxButton(:hint="$tCaption('Manage permissions')", stylingMode="text", icon="checklist", @click="$refs.permissions.manage(data.Oid)")
													span {{$refs.permissions.getCompanyPermissionText(data.Oid)}}
										ListView(:visible="tab == 'agencies'", name="agencies", :columnHidingEnabled="true", ref="agencies", initialView="table", :hideViewsSelection="true", 
											:getTotal="(r) => { totalAgencies = r.TotalNumberOfRecords; return r.TotalNumberOfRecords; }", :getItems="r => r.Results", :getData="(a,b,c) => $Data.getExternalCompanies(a, b, {...(c || {}), byType: 2 })", 
											:columns="companiesByTypeColumns")
											.flex-row.space.align-center(slot="left-actions")
												DxButton(icon="fas fa-briefcase", :text="$tCaption('Invite agency')" @click="openCompanyInvite(2)")
											template(v-slot:name-cell-template="{ data }")
												LinkedCompanyName(:company="data", @invited="$refs.agencies.reload()")
											template(v-if="isPermissionsLoaded", v-slot:permissions-cell-template="{ data }")
												.flex-row.full-width.justify.align-center
													DxButton(:hint="$tCaption('Manage permissions')", stylingMode="text", icon="checklist", @click="$refs.permissions.manage(data.Oid)")
													span {{$refs.permissions.getCompanyPermissionText(data.Oid)}}
										ListView(:visible="tab == 'advertisers'", name="advertisers", :columnHidingEnabled="true", ref="advertisers", initialView="table", :hideViewsSelection="true", 
											:getTotal="(r) => { totalAdvertisers = r.TotalNumberOfRecords; return r.TotalNumberOfRecords; }", :getItems="r => r.Results", :getData="(a,b,c) => $Data.getExternalCompanies(a, b, {...(c || {}), byType: 0 })", 
											:columns="companiesByTypeColumns")
											.flex-row.space.align-center(slot="left-actions")
												DxButton(icon="fas fa-user", :text="$tCaption('Invite advertiser')" @click="openCompanyInvite(0)")
											template(v-slot:name-cell-template="{ data }")
												LinkedCompanyName(:company="data", @invited="$refs.advertisers.reload()")
											template(v-if="isPermissionsLoaded", v-slot:permissions-cell-template="{ data }")
												.flex-row.full-width.justify.align-center
													DxButton(:hint="$tCaption('Manage permissions')", stylingMode="text", icon="checklist", @click="$refs.permissions.manage(data.Oid)")
													span {{$refs.permissions.getCompanyPermissionText(data.Oid)}}
										ListView(:visible="tab == 'companiesInvites'", name="companiesInvites", :columnHidingEnabled="true", ref="companiesInvites", initialView="table", :hideViewsSelection="true", :getTotal="(r) => { totalInvites = r.TotalNumberOfRecords; return r.TotalNumberOfRecords; }", :getItems="r => r.Results", :getData="$Data.getActiveCompanyInvites", :columns="invitedCompaniesColumns")
											template(v-slot:company-type-cell-template="{ data }")
												span {{data.CompanyType === 0 ? $tCaption('Advertier') : (data.CompanyType === 1 ? $tCaption('Agency') : $tCaption('Station owner'))}}
										CustomerInvoicesList(v-if="tab == 'invoices'" :company="company")
						Popup(v-if="invitePopup.visible", :popupVisible.sync="invitePopup.visible", :width="400", :autosize="true", :title="$tCaption('New invite')")
							.flex-col.space-large
								.flex-col.field.space
									.font-small.upper.grey {{$tCaption('Name')}}
									dx-text-box(
										:value.sync="invite.Title"
										width="100%"
										:disabled="invitePopup.processing",
										:input-attr="{ autocomplete: 'new-password', id: 'contactInviteName' }"
										valueChangeEvent="input"
									)
										dx-validator
											dx-required-rule(:message="$tCaption('Name is required')")
								.flex-col.field.space
									.font-small.upper.grey {{$tCaption('Email')}}
									dx-text-box(
										ref="contactInviteEmail"
										:value.sync="invite.Email"
										width="100%"
										:disabled="invitePopup.processing",
										:input-attr="{ autocomplete: 'new-password', id: 'contactInviteEmail'  }"
										valueChangeEvent="input"
									)
										dx-validator
											dx-required-rule(:message="$tCaption('Email is required')")
								.flex-col.field.space
									.font-small.upper.grey {{$tCaption('Message')}}
									dx-text-area(
										:value.sync="invite.InvitationText"
										width="100%"
										:disabled="invitePopup.processing",
										:input-attr="{ autocomplete: 'new-password', id: 'contactInviteMessage' }"
										valueChangeEvent="input"
									)
								DxCheckBox(:text="$tCaption('Private Folder Access Only')", :value.sync="invite.PrivateFolderOnly")
							.flex-row.space(slot="actions-right")
								DxButton(:text="$tCaption('Cancel', '@actions')", @click="invitePopup.visible = false")
								DxButton(:text="$tCaption('Send invite')", icon="email", type="default", @click="doSendInvite", :disabled="invitePopup.processing")
			dx-item(title="Subscriptions")
				template(#default)
					Subscriptions().tb-padding
			dx-item(title="External Services")
				template(#default)
					ExternalServices().tb-padding
			dx-item(v-if="hasAICreativeIntegration", title="Integration")
				template(#default)
					EasyCreativeIntegrationSettings.tb-padding
		InviteCompany(ref="inviteCompany", @sent="onInviteSent")
		CompanyPermissions(ref="permissions", @loaded="v => isPermissionsLoaded = v")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import DxTextArea from 'devextreme-vue/text-area';
	import Loader from 'app-core/Loader.vue';
	import DxValidationGroup from 'devextreme-vue/validation-group';
	import DxValidator, {DxRequiredRule, DxCustomRule} from 'devextreme-vue/validator';
	import ListView from 'app-core/ListView.vue';
	import Popup from 'app-core/Popup.vue';
	import Subscriptions from './Subscriptions.vue';
	import InviteCompany from './InviteCompany.vue';
	import CustomerInvoicesList from './CustomerInvoicesList.vue';
	import DetailContactsTabs from './DetailContactsTabs.vue';
	import ExternalServices from 'view/webServiceCaller/List.vue';
	import LinkedCompanyName from './LinkedCompanyName.vue';
	import DxTabPanel, { DxItem } from 'devextreme-vue/tab-panel';
	import Dropdown from 'app-core/Dropdown.vue';
	import CompanyPermissions from './CompanyPermissions.vue';
	import EasyCreativeIntegrationSettings from 'view/creative/EasyCreative/EasyCreativeIntegrationSettings.vue';
	import DxCheckBox from 'devextreme-vue/check-box';

	export default {
		translationCategory: 'company.Detail',
		name: 'company-detail',
		props: ['id', 'activeTab', 'page'],
		components: {
			DxButton, DxTextBox, Loader, DxDateBox, DxTextArea, DxCheckBox,
			DxValidationGroup, DxValidator, DxRequiredRule, DxCustomRule, ListView,
			Popup, Subscriptions, InviteCompany, CustomerInvoicesList, DetailContactsTabs,
			ExternalServices, LinkedCompanyName, DxTabPanel, DxItem, Dropdown, CompanyPermissions, EasyCreativeIntegrationSettings
		},
		data() {
			return {
				company: null,
				isSaving: false,
				isLoading: false,
				isPermissionsLoaded: false,
				registeredContactsColumns: [
					{ dataField: 'Title', caption: () => this.$tCaption('Title') },
					{ dataField: 'Email', caption: () => this.$tCaption('Email') },
					{ dataField: 'Phone', caption: () => this.$tCaption('Phone') },
					{ dataField: 'Title', name: 'Title1', caption: ' ', cellTemplate: 'listing-cell-template', serverField: 'Title', width: '60px' }
				],
				invitedContactsColumns: [
					{ dataField: 'Title', caption: () => this.$tCaption('Title') },
					{ dataField: 'Email', caption: () => this.$tCaption('Email') },
					{ dataField: 'Title', name: 'Title1', caption: ' ', cellTemplate: 'listing-cell-template', serverField: 'Title'  }
				],
				waitingApproveContactsColumns: [
					{ dataField: 'Title', caption: () => this.$tCaption('Title') },
					{ dataField: 'Email', caption: () => this.$tCaption('Email') },
					{ dataField: 'Title', name: 'Title1', caption: ' ', cellTemplate: 'listing-cell-template', serverField: 'Title' }
				],
				companiesByTypeColumns: [
					{ dataField: 'Name', caption: () => this.$tCaption('Name'), cellTemplate: 'name-cell-template' },
					{ dataField: 'Country.Name', caption: () => this.$tCaption('Country') },
					{ dataField: 'City', caption: () => this.$tCaption('City') },
					{ dataField: 'State', caption: () => this.$tCaption('State') },
					{ dataField: 'Zip', caption: () => this.$tCaption('Zip') },
					{ dataField: 'Address', caption: () => this.$tCaption('Address') },
					{ dataField: 'Address2', caption: () => this.$tCaption('Address 2') },
					{ dataField: 'Address3', caption: () => this.$tCaption('Address 3') },
					{ dataField: 'Name', name: 'Name1', caption: () => this.$tCaption('Permissions'), cellTemplate: 'permissions-cell-template' },
				],
				invitedCompaniesColumns: [
					{ dataField: 'Name', caption: () => this.$tCaption('Name')},
					{ dataField: 'Email', caption: () => this.$tCaption('Email') },
					{ dataField: 'CompanyType', caption: () => this.$tCaption('Company type'), cellTemplate: 'company-type-cell-template', alignment: 'left' },
				],
				invite: {
					Title: null,
					Email: null,
					InvitationText: null,
					PrivateFolderOnly: false
				},
				invitePopup: {
					processing: false,
					visible: false
				},
				tab: this.activeTab || 'contacts',
				activatedTabs: {},
				mainTabIndex: 0,
				contactsTab: 'registered',
				totalRegistered: 0,
				totalInvited: 0,
				totalWaitingApproval: 0,
				totalStations: 0,
				totalAgencies: 0,
				totalAdvertisers: 0,
				totalInvites: 0,
				approvingContacts: [],
				hasAICreativeIntegration: false
			};
		},
		watch: {
			id(v) {
				if (v)
					this.loadCompany();
			},
			company: {
				handler() {
					this.save();
				},
				deep: true
			},
			page() {
				this.checkMainTab();
			},
			tab(v) {
				this.$set(this.activatedTabs, v, true);
			}
		},
		mounted() {
			if (__DEBUG__)
				window.companyProfile = this;
			this.checkMainTab();
			this.loadCompany();
			this.checkHasIntegration();
		},
		methods: {
			async checkHasIntegration() {
				this.hasAICreativeIntegration = (await this.$Data.getExternalApi('BriefIntegrationSetting/List', `page=1&filterCriteria=["Owner.Oid", "=", "${this.$auth.companyId()}"]`, 1))?.Results?.length > 0;
			},
			checkMainTab() {
				this.mainTabIndex = this.page === 'subscriptions' ? 1 : (this.page === 'services' ? 2 : 0);
			},
			onInviteSent() {
				this.$refs.companiesInvites?.reload();
			},
			openAdServerDownload() {
				window.open(this.adServerDownloadLink);
			},
			getCounted(text, count) {
				if (!count) return text;
				return `${text} (${count})`;
			},
			approveContact(contact) {
				if (__DEBUG__)
					console.debug('Approve contact', {contact});
				this.approvingContacts.push(contact.Oid);
				this.$Data.getExternalApi('Security/SetUserActive', `contactId=${contact.Oid}&active=true`).then(r => {
					if (r.Success) {
						this.$refs.waitinigApproveUsers.reload();
						this.$refs.registeredUsers.reload();
						this.$notifySuccess(this.$tCaption('Contact approved'));
					} else {
						this.$notifyError(r.ErrorMessage);
					}
				}).finally(() => this.approvingContacts.splice(this.approvingContacts.indexOf(contact.Oid), 1));
			},
			refreshCurrentTabData() {
				if (this.tab !== 'contacts') return;
				switch (this.contactsTab) {
					case 'registered':
						this.$refs.registeredUsers.reload();
						break;
					case 'invited':
						this.$refs.invitedUsers.reload();
						break;
					case 'waitingApprove':
						this.$refs.waitinigApproveUsers.reload();
						break;
				}
			},
			deleteContact(contact) {
				this.$confirmMessage({
					title: this.$tCaption('Confirm action', '@actions'),
					text: this.$tCaption('Are you sure you want to delete this contact?'),
					handler: () => {
						this.$Data.getExternalApi('Company/DeleteContact', `id=${contact.Oid}`).then((r) => {
							if (r.Success) {
								this.$notifySuccess(this.$tCaption('Contact deleted'), 'success', 600);
								this.refreshCurrentTabData();
							} else {
								this.$notifyError(r.ErrorMessage);
							}
						});
					}
				});
			},
			openInvite() {
				this.invitePopup.visible = false;
				this.invite.Title = null;
				this.invite.Email = null;
				this.invite.InvitationText = null;
				this.invite.PrivateFolderOnly = false;
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.invitePopup.visible = true;
				});
			},
			doSendInvite(e) {
				if (!e.validationGroup.validate().isValid) {
					return;
				}
				this.invitePopup.processing = true;
				this.$Data.postExternalApi('Company/CreateContactAndSendInvite', {
					...this.invite,
					Company: {
						Oid: this.company.Oid
					}
				}).then(r => {
					if (r.Success) {
						this.$refs.invitedUsers.reload();
						this.invitePopup.visible = false;
					} else {
						this.$notifyError(r.ErrorMessage);
					}
				}).finally(() => this.invitePopup.processing = false);
			},
			openCompanyInvite(type) {
				this.$refs.inviteCompany.openCompanyInvite({CompanyType: type});
			},
			getCompanyContacts(pageIndex, limit, opts, status) {
				return this.$Data.getCompanyContacts(pageIndex, limit, opts, this.company.Oid, status);
			},
			loadCompany() {
				if (!this.id) return;
				this.isLoading = true;
				return this.$Data.getExternalCompanies(0, 1, {byKey: this.id}).then(r => {
					this.company = r.Results[0];
				}).finally(() => this.isLoading = false);
			},
			save() {
				if (this.isSaving || this.isLoading) return;
				if (__DEBUG__)
					console.debug('Saving', this.isSaving);

				this.isSaving = true;

				return this.$Data.postExternalApi('Company/CreateUpdateCompany', this.company).then(r => {
					if (this._isDestroyed) return;
					if (r.Success) {
						this.$notifySuccess(this.$tCaption('Data updated'));
					} else {
						this.$notifyError(r.ErrorMessage);
					}
				}).finally(() => {
					this.isSaving = false;
				});
			},
		}
	};
</script>
<style lang='scss'>
	.company-detail {
		.detail-tile {
			background: rgba(0, 0, 0, 0.03);
			padding: 4px;
			border-radius: 4px;
		}
	}
</style>
 